import { render, staticRenderFns } from "./LeftSidebarLayout.vue?vue&type=template&id=2bd6adc4&"
import script from "./LeftSidebarLayout.vue?vue&type=script&lang=js&"
export * from "./LeftSidebarLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports